import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { withReportSubscription } from 'State/report/withReportSubscription';

import { Filter, Main } from 'Containers/';
import { NUTRITION_STANDARDS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { NutritionStandardsReportFieldEnum } from 'Common/FieldEnum';

import { NutritionStandardsReportForm } from './components/NutritionStandardsReportForm';
import * as NutritionStandardsReportActions from './state/actions';
import * as NutritionStandardsReportSelectors from './state/selectors';

class NutritionStandardsReportContainer extends Component {
  componentDidMount() {
    const { getNutritionStandards } = this.props;

    getNutritionStandards();
  }

  handleSubmit = (values) => {
    const { getReport, nutritionStandardsResult } = this.props;
    const nutritionStandardId = values.NutritionStandard;
    const nutritionStandardSelected = nutritionStandardsResult.find(
      (std) => std.Id === nutritionStandardId
    );
    const {
      MealType,
      GradeFrom,
      GradeTo,
      Description,
      Id,
    } = nutritionStandardSelected;

    const { ...params } = {
      MealType: MealType,
      AgeFrom: GradeFrom,
      AgeTo: GradeTo,
      NutritionStandardId: Id,
      Description: Description,
    };

    getReport('reports/NutritionStandardReport', params);
  };

  getMainProps = () => {
    const { reportFetching } = this.props;

    const toolbox = {
      shown: true,
      formName: NUTRITION_STANDARDS_REPORT_FORM_NAME,
      saveButtonProps: {
        content: 'View',
        loading: reportFetching,
        disabled: reportFetching,
      },
    };

    return { toolbox };
  };

  render() {
    const {
      reportFetching,
      nutritionStandardsOptions,
      getNutritionStandardsLoading,
    } = this.props;

    return (
      <React.Fragment>
        <Filter title="USDA Nutrition Standards" />

        <Main shouldUsePageWidth {...this.getMainProps()}>
          <NutritionStandardsReportForm
            onSubmit={this.handleSubmit}
            nutritionStandards={nutritionStandardsOptions}
            nutritionStandardsLoading={getNutritionStandardsLoading}
            loading={reportFetching}
            initialValues={{
              [NutritionStandardsReportFieldEnum.NutritionStandard]: 0,
            }}
          />
        </Main>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getNutritionStandardsLoading: NutritionStandardsReportSelectors.getNutritionStandardsLoading(
      state
    ),
    getNutritionStandardsErrors: NutritionStandardsReportSelectors.getNutritionStandardsErrors(
      state
    ),

    nutritionStandardsOptions: NutritionStandardsReportSelectors.nutritionStandardOptions(
      state
    ),
    nutritionStandardsResult: NutritionStandardsReportSelectors.getNutritionStandardsResult(
      state
    ),
  };
};

const mapDispatchToProps = {
  change: (...args) => change(NUTRITION_STANDARDS_REPORT_FORM_NAME, ...args),

  getNutritionStandards: NutritionStandardsReportActions.getNutritionStandards,
  clearGetNutritionStandardsResult:
    NutritionStandardsReportActions.clearGetNutritionStandardsResult,
};

export const NutritionStandardsReport = withReportSubscription(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NutritionStandardsReportContainer)
);

NutritionStandardsReport.path = '/nutritionstandardsreport';



// WEBPACK FOOTER //
// ./src/pages/nutritionstandardsreport/NutritionStandardsReport.js